<script>
    import { WIZARD } from './context.js';
    import { getContext } from 'svelte';

    export let title = "";
    export let key = "";
    export let showNextButton = true;
    export let icon = "";

    const {registerStep, activeStep, isFinished} = getContext(WIZARD)

    registerStep({key, title, showNextButton, icon})
</script>

{#if !$isFinished && $activeStep && $activeStep.key == key}
    <slot></slot>
{/if}